export const FX_API_BASE = window.__RUNTIME_CONFIG__.FX_API
export const EXPLORER_BASE = window.__RUNTIME_CONFIG__.EXPLORER || 'https://explorer.testnet.nahmii.io'
export const PROTOCOL_DATA_PROVIDER_ADDRESS =
  window.__RUNTIME_CONFIG__.PROTOCOL_DATA_PROVIDER_ADDRESS || '0x3c73a5e5785cac854d468f727c606c07488a29d6'
export const LENDING_POOL_CONTRACT_ADDRESS =
  window.__RUNTIME_CONFIG__.LENDING_POOL_CONTRACT_ADDRESS || '0xe0fba4fc209b4948668006b2be61711b7f465bae'
export const LENDING_PRICE_PROVIDER_ADDRESS =
  window.__RUNTIME_CONFIG__.LENDING_PRICE_PROVIDER_ADDRESS || '0xb8be51e6563bb312cbb2aa26e352516c25c26ac1'
export const FARMII_URL = window.__RUNTIME_CONFIG__.FARMII_URL || 'https://app.farmii.io/'
